// AUTO-GENERATED. Do not edit by hand.
// Source: ExportedCharacterData/*.asset (LitLegion Unity project)
// Regenerate with: npx tsx scripts/extract-litsquad-avatar-transforms.ts

/**
 * Local mirror of `LitSquadSpecies` from `@fias/db-types`.
 * `@fias/litsquad-avatar` is dependency-free, so this file inlines the
 * union of species names. The list and its order are pinned to the
 * canonical `LITSQUAD_SPECIES` array by the architecture test
 * `tests/architecture/litsquad-species-parity.test.ts`.
 */
export type LitSquadSpeciesName =
  | 'Alien'
  | 'Bear'
  | 'Bird'
  | 'Cat'
  | 'Crab'
  | 'Dinosaur'
  | 'Dog'
  | 'Dragon'
  | 'Elephant'
  | 'Fish'
  | 'Flabby'
  | 'Gorilla'
  | 'Insect'
  | 'Plant'
  | 'Robot'
  | 'Rodent'
  | 'Snake';

/**
 * Maps each LitSquad species name to the integer character index used
 * by the Unity `Avatar:` field on `ExportedCharacterData/*.asset`.
 *
 * The accessory transform tables key off this index, so the mapping
 * MUST match the Unity build exactly.
 */
export const LITSQUAD_CHARACTER_INDEX: Record<LitSquadSpeciesName, number> = {
  Alien: 0,
  Bear: 1,
  Bird: 2,
  Cat: 3,
  Crab: 4,
  Dinosaur: 5,
  Dog: 6,
  Dragon: 7,
  Elephant: 8,
  Fish: 9,
  Flabby: 10,
  Gorilla: 11,
  Insect: 12,
  Plant: 13,
  Robot: 14,
  Rodent: 15,
  Snake: 16,
};

/** Inverse of LITSQUAD_CHARACTER_INDEX. */
export const LITSQUAD_SPECIES_BY_INDEX: readonly LitSquadSpeciesName[] = [
  'Alien',
  'Bear',
  'Bird',
  'Cat',
  'Crab',
  'Dinosaur',
  'Dog',
  'Dragon',
  'Elephant',
  'Fish',
  'Flabby',
  'Gorilla',
  'Insect',
  'Plant',
  'Robot',
  'Rodent',
  'Snake',
] as const;

/** Returns the character index for a species, or null if not a known species. */
export function getLitSquadCharacterIndex(species: string | null | undefined): number | null {
  if (!species) return null;
  const value = (LITSQUAD_CHARACTER_INDEX as Record<string, number | undefined>)[species];
  return typeof value === 'number' ? value : null;
}
